import styles from './FormNavigationLink.module.scss';

const TOUR_APP_URL = import.meta.env.TOURPWA_TOUR_APP_URL;

interface IFormNavigationLinkProps {
  page: string;
  label: string;
  token: string;
  className?: string;
  buttonClassName?: string;
  target?: string;
}

function FormNavigationLink({ page, label, token, className = '', buttonClassName = styles.sidebarButton, target }: IFormNavigationLinkProps) {
  const needsReturnUrl = page.includes('?') || page.includes('#');
  return (
    <div>
      <form action={`${TOUR_APP_URL}/${page}`} method="POST" target={target} rel={target === '_blank' ? 'noreferrer' : undefined} className={`${styles.sidebarForm} ${className}`}>
        <input type="hidden" name="jwt" value={token} />
        {needsReturnUrl && <input type="hidden" name="returnUrl" value={`/${page}`} />}
        <button type="submit" className={buttonClassName}>
          {label}
        </button>
      </form>
    </div>
  );
}

export default FormNavigationLink;
